module.exports = __webpack_public_path__ + "static/media/kitchen-living_light.b9317245.jpg";